export const replaceLightframe = (partnerSlug: string) => {
    if (partnerSlug.match(/\bid\d+\b(?!\w)/)) {
        return partnerSlug.replace('id', '');
    }

    return partnerSlug.replace('lightframe', '');
};
